<template>
  <div class="mt-3">
    <div class="home-moving-title font-class">[家居搬運服務]</div>
    <div class="mt-3rem mb-5rem">
      <v-form v-model="valid" ref="form" class="form"  lazy-validation>
        <input-container
          ref="inputContainer"
          :configs="inputConfigs"
        ></input-container>
        <p class="text-h5">
          特別聲明：因為本公司所能承擔的賠償責任有限（賠償責任最高為搬運費的15%），要想在搬運過程中或存倉期間萬一因意外地損壞或遺失的物 品得到最大賠償，我們建議客人在搬運前購買搬運或家居保險。
        </p>
        <p class="text-h5">
          Declaration：The company can bear limited liability (compensation liability is up to 15% of the total service fee of removal). If more comprehensive protection is required (including the removal process and storage), it is recommended that customers purchase insurance before removal.
        </p>
        <v-btn
          x-large
          dark
          color="rgba(54,77,137,1)"
          rounded
          @click="submit"
        >
          <div class="ml-10 mr-10 text-h5">發送 Submit</div>
        </v-btn>
      </v-form>
      <form-editor
        :show="debug"
        :inputConfigs="inputConfigs"
        @update="updateConfig"
      ></form-editor>
    </div>
    <span v-if="!isMobile">
      <BackToTop target="" ref="backToTop"></BackToTop>
      <WhatsappBtn
        whatsappNumber="85264184666"
      ></WhatsappBtn>
    </span>
  </div>
</template>

<style scoped>
  .mt-3rem{
    margin-top: 3rem;
  }
  .mb-5rem{
    margin-bottom: 5rem;
  }
  .font-class{
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
  }
  .home-moving-title{
    font-weight: bold;
    font-size: 45px;
    color: rgba(54,77,137,1);
  }
</style>
<script>
import common from '@/components/mixin/common'
import { sendHomeMovingEmail } from '@/api/email'
import FormEditor from '@/components/CRUD/FormEditor'
import InputContainer from '@/components/CRUD/InputContainer'
import BackToTop from '@/components/BackToTop'
import WhatsappBtn from '@/components/WhatsappBtn'
export default {
  name: 'HomeMoving',
  mixins: [common],
  components: {
    InputContainer,
    FormEditor,
    BackToTop,
    WhatsappBtn
    // UniversalInput
  },
  methods: {
    submit () {
      if (this.$refs.inputContainer) {
        if (this.valid) {
          console.log('this.$refs.inputContainer.editedItem', this.$refs.inputContainer.editedItem)
          // return this.$refs.inputContainer.editedItem
          sendHomeMovingEmail(this.$refs.inputContainer.editedItem).then((response) => {
            console.log(response)
            window.alert('Order sent to Champion Moving. A copy would sent to email with aboth address for reference.')
          }).catch((error) => {
            console.log(error)
            window.alert('Error occur. Please contact support.')
          })
        } else {
          window.alert('Please fill in the required information.')
          console.log(this.$refs)
          this.$refs.backToTop.backToTop()
        }
      } else {
        console.log('this.$refs.inputContainer', this.$refs.inputContainer)
      }
    },
    updateConfig (configs) {
      this.inputConfigs = configs
    }
  },
  props: {
    debug: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      checkbox: false,
      checkbox2: false,
      valid: true,
      inputConfigs: [
        {
          md: 12,
          sm: 12,
          sectionTitle: '聯絡資料 Information'
        },
        {
          md: 4,
          sm: 12,
          offsetRightMd: 8,
          propName: 'clientName',
          toplabel: '姓名 Name',
          type: {
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 4,
          sm: 12,
          offsetRightMd: 8,
          propName: 'clientPhone',
          toplabel: '手提電話 Mobile Number',
          type: {
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 4,
          sm: 12,
          offsetRightMd: 8,
          propName: 'email',
          toplabel: '電郵 Email'
        },
        {
          md: 6,
          sm: 12,
          offsetRightMd: 6,
          propName: 'currentAddress',
          toplabel: '舊地址 Current Address',
          type: {
            name: 'textarea',
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 12,
          sm: 12,
          propName: 'currentAddressInfo',
          toplabel: '舊地址信息 Current Address Info',
          type: {
            name: 'checkbox',
            checkboxItems: [
              {
                itemName: 'noLift',
                label: '沒有電梯 No Lift'
              },
              {
                itemName: 'stairs',
                label: '有樓梯 Internal Stairs'
              },
              {
                itemName: 'exchange',
                label: '需要平台轉𨋢 Needed to exchange the elevator in loading area'
              }
            ]
          }
        },
        {
          md: 6,
          offsetRightMd: 6,
          propName: 'newAddress',
          toplabel: '新地址 New Address',
          type: {
            name: 'textarea',
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 12,
          propName: 'newAddressInfo',
          toplabel: '新地址信息 New Address Info',
          type: {
            name: 'checkbox',
            checkboxItems: [
              {
                itemName: 'noLift',
                label: '沒有電梯 No Lift'
              },
              {
                itemName: 'stairs',
                label: '有樓梯 Internal Stairs'
              },
              {
                itemName: 'exchange',
                label: '需要平台轉𨋢 Needed to exchange the elevator in loading area'
              }
            ]
          }
        },
        {
          md: 4,
          sm: 12,
          offsetRightMd: 8,
          propName: 'expectedDate',
          toplabel: '預計搬遷日期 Expected Relocation Date',
          label: 'YYYY-MM-DD',
          type: {
            name: 'datepicker',
            required: true,
            allowedDates: (val) => {
              return val >= new Date().toISOString().substr(0, 10)
            },
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 12,
          sm: 12,
          sectionTitle: '櫃 Cabinet'
        },
        {
          md: 4,
          sm: 12,
          propName: 'cabinet_storageCombinations',
          toplabel: '組合櫃 Storage Combinations',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          sm: 12,
          propName: 'cabinet_wardrobe1',
          toplabel: '衣櫃 (單門) Wardrobe (1 door)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          sm: 12,
          propName: 'cabinet_wardrobe2',
          toplabel: '衣櫃 (雙門) Wardrobe (2 doors)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          sm: 12,
          propName: 'cabinet_wardrobe3',
          toplabel: '衣櫃 (三門) Wardrobe (3 doors)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          sm: 12,
          propName: 'cabinet_wardrobe4',
          toplabel: '衣櫃 (四門) Wardrobe (4 doors)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '床 Bed'
        },
        {
          md: 4,
          propName: 'bed_single',
          toplabel: '床 (單人) Single Bed',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'bed_double',
          toplabel: '床 (雙人) Double Bad',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'bed_bunk',
          toplabel: '床 (上下格) Bunk Bed',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'bed_compound',
          toplabel: '組合床 Compound Bed',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'bed_mattress',
          toplabel: '床褥 Mattress',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '電視櫃 TV Benches'
        },
        {
          md: 4,
          propName: 'tvbenches_25_4',
          toplabel: '電視櫃 TV Benches (2.5-4呎 / 2.5-4 feet)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'tvbenches_5',
          toplabel: '電視櫃 TV Benches (5呎 / 5 feet)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'tvbenches_5ormore',
          toplabel: '電視櫃 TV Benches (5呎或以上)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '餐桌連椅 Dining tables'
        },
        {
          md: 4,
          propName: 'table_wood',
          toplabel: '餐桌連椅 (木製) Wooden table and sets',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'table_marble',
          toplabel: '餐桌連椅 (雲石) Marble table and sets',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'table_glass',
          toplabel: '餐桌連椅 (玻璃) Glass table and sets',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '梳化 Sofa'
        },
        {
          md: 4,
          propName: 'sofa_1',
          toplabel: '梳化 (單座位) Single Sofa',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'sofa_2',
          toplabel: '梳化 (兩座位) 2 Seater Sofa',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'sofa_3',
          toplabel: '梳化 (三座位) 3 Seater Sofa',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'sofa_l',
          toplabel: '梳化 (L 型) L-shape Sofa',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '水族箱 Aquarium'
        },
        {
          md: 4,
          propName: 'aquarium2436',
          toplabel: '水族箱 Aquarium (24-36吋 / inches)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'aquarium37',
          toplabel: '水族箱 Aquarium (37吋或以上/inches or more)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '電視 TV'
        },
        {
          md: 4,
          propName: 'tv_3039',
          toplabel: '電視 TV (30-39 吋 / inches)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'tv_40ormore',
          toplabel: '電視 (40吋或以上 / inches or more)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '電器'
        },
        {
          md: 4,
          propName: 'refrigerator',
          toplabel: '雪櫃 Refrigerator',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'waterplane',
          toplabel: '水機 Waterplane',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'dehumidifier',
          toplabel: '抽濕機 Dehumidifier',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'microwaveOven',
          toplabel: '微波爐/焗爐 Microwave Oven',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'washingMachine',
          toplabel: '洗衣機 Washing Machine',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'clothesDryer',
          toplabel: '乾衣機 Clothes Dryer',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'computer',
          toplabel: '電腦 Computer',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'massageChair',
          toplabel: '按摩椅 Massage Chair',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'floorFan',
          toplabel: '座地風扇 Floor Fan',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'avCombination',
          toplabel: '影音組合 AV Combination',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'heater',
          toplabel: '暖爐 Heater',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'floorLamp',
          toplabel: '座地燈 Floor Lamp',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'chandelier',
          toplabel: '吊燈 Chandelier',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '傢俬 Furniture'
        },
        {
          md: 4,
          propName: 'sideboards',
          toplabel: '地櫃 Sideboards',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'shoebox',
          toplabel: '鞋櫃 Shoebox',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'bedsideTable',
          toplabel: '床頭櫃 Bedside Table',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'Drawers5',
          toplabel: '五桶櫃 Chest of 5 Drawers',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'glassCabinets',
          toplabel: '玻璃飾櫃 Glass Cabinets',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'kitchenCabinets',
          toplabel: '廚櫃 Kitchen Cabinets',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'altarTable',
          toplabel: '神櫃 Altar Table',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'bookcase',
          toplabel: '書櫃 Bookcase',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'shelvingUnits',
          toplabel: '層架櫃 Shelving Units',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'foldingTable',
          toplabel: '槢枱 Folding Table',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'desks',
          toplabel: '書枱 Desks',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'officeDesk',
          toplabel: '電腦枱 Office Desk',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'officeChair',
          toplabel: '辦公椅 Office Chair',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'coffeeTable',
          toplabel: '茶几 Coffee Table',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'shelf_UtilityBook',
          toplabel: '雜物架/書架 Utility Shelf / Book Shelf',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'screen',
          toplabel: '屏風 Screen',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'dessingTable',
          toplabel: '梳妝枱 Dressing Table',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'wineCabinet',
          toplabel: '酒櫃 Wine Cabinet',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'fitnessEquipment',
          toplabel: '健身器材 Fitness Equipment',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '其他雜物 Others'
        },
        {
          md: 4,
          propName: 'plasticCabinet',
          toplabel: '膠櫃 Plastic Boxes',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'artPiece',
          toplabel: '畫 Art Piece',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'rugs',
          toplabel: '地毯 Rugs',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'bicycle',
          toplabel: '單車 Bicycle',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'hanger',
          toplabel: '掛衫架 Hanger',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'grill',
          toplabel: '燒烤爐 Grill',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'safe',
          toplabel: '夾萬 Safe',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'piano',
          toplabel: '鋼琴 Piano',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'trunk',
          toplabel: '行李箱 Trunk',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pc',
                id: 2
              },
              {
                label: '3件/pc',
                id: 3
              },
              {
                label: '4件/pc',
                id: 4
              },
              {
                label: '5件/pc',
                id: 5
              },
              {
                label: '6件/pc',
                id: 6
              },
              {
                label: '7件/pc',
                id: 7
              },
              {
                label: '8件/pc',
                id: 8
              },
              {
                label: '9件/pc',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'plasticBoxes',
          toplabel: '膠箱/盒 Plastic Boxes',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-5件/pcs',
                id: 1
              },
              {
                label: '6-10件/pcs',
                id: 2
              },
              {
                label: '11-20件/pcs',
                id: 3
              },
              {
                label: '20件或以上/or more pcs',
                id: 4
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'plasticBags',
          toplabel: '膠袋 Plastic Bags',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-5件/pcs',
                id: 1
              },
              {
                label: '6-10件/pcs',
                id: 2
              },
              {
                label: '11-20件/pcs',
                id: 3
              },
              {
                label: '20件或以上/or more pcs',
                id: 4
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'cartonBox',
          toplabel: '紙箱 Carton Box',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-10件/pcs',
                id: 1
              },
              {
                label: '11-20件/pcs',
                id: 2
              },
              {
                label: '21-30件/pcs',
                id: 3
              },
              {
                label: '31-40件/pcs',
                id: 4
              },
              {
                label: '41-50件/pcs',
                id: 5
              },
              {
                label: '51-60件/pcs',
                id: 6
              },
              {
                label: '61-70件/pcs',
                id: 7
              },
              {
                label: '71-80件/pcs',
                id: 8
              },
              {
                label: '81-90件',
                id: 9
              },
              {
                label: '91-100件/pcs',
                id: 10
              },
              {
                label: '100件或以上/or more pc/pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 6,
          offsetRightMd: 6,
          propName: 'otherItems',
          toplabel: '其他物件 (請特別註明) Other Items (Please Specify)',
          type: {
            name: 'textarea'
          }
        }
      ]
    }
  }
}
</script>
